export default "__VITE_ASSET__BRZ1AtrA__"